import React, { Component } from "react";
import { MDBNavbar, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBCollapse, MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem,
  MDBHamburgerToggler } from 'mdbreact';
import { BrowserRouter as Router } from 'react-router-dom';
import { Link } from "react-router-dom";


class Mobile_menu extends Component {
  state = {
    collapse1: false,
    collapseID: ''
  }
  
  toggleCollapse = collapseID => () => {
    this.setState(prevState => ({ collapseID: (prevState.collapseID !== collapseID ? collapseID : '') }));
  }
  
  toggleSingleCollapse = collapseId => {
    this.setState({
      ...this.state,
      [collapseId]: !this.state[collapseId]
    });
  }
  

  render() {

    return (

      <Router>

        <MDBNavbar>
          <MDBHamburgerToggler id="hamburger1" onClick={()=> this.toggleSingleCollapse('collapse1')} />
            <MDBCollapse isOpen={this.state.collapse1} navbar>
              <MDBNavbarNav left>
                <MDBNavItem>
                    <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Home</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                          <MDBDropdownItem to={process.env.PUBLIC_URL + '/'}>Home 01</MDBDropdownItem>
                          <MDBDropdownItem to={process.env.PUBLIC_URL + '/Home2'}>Home 02</MDBDropdownItem>
                          <MDBDropdownItem to={process.env.PUBLIC_URL + '/Home3'}>Home 03</MDBDropdownItem>
                      </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                    <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Pages</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/about_us'}>About Us</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/about_us_2'}>About us 2</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/contact_01'}>Contact us 01</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/contact_02'}>Contact us 02</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/services'}>Services 1</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/services_2'}>Services 2</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Our_team'}>Our Team</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Team_details'}>Team Details</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Pricing'}>Pricing</MDBDropdownItem>
                      </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem> 
                <MDBNavItem>
                  <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Services</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Alterations_repairs'}>Alterations & repairs</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Commercial_laundry'}>Commercial laundry</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/dry_cleaning'}>Dry cleaning</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Laundry_services'}>Laundry services</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Leather_cleaning'}>Leather cleaning</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Steam_iron'}>Steam iron</MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                    <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Case Study</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                          <MDBDropdownItem to={process.env.PUBLIC_URL + '/Our_case_study'}>Our Case Study</MDBDropdownItem>
                          <MDBDropdownItem to={process.env.PUBLIC_URL + '/Case_study_details'}>Case Study Details</MDBDropdownItem>
                      </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                    <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Blog</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Blog'}>Blog</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Blog_grid_view'}>Blog grid View</MDBDropdownItem>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/Blog_details'}>Blog Details</MDBDropdownItem>
                    </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>
                <MDBNavItem>
                    <MDBDropdown>
                      <MDBDropdownToggle nav caret>
                          <span>Contact Us</span>
                      </MDBDropdownToggle>
                      <MDBDropdownMenu>
                        <MDBDropdownItem to={process.env.PUBLIC_URL + '/contact_01'}>Contact us 01</MDBDropdownItem>
                      </MDBDropdownMenu>
                    </MDBDropdown>
                </MDBNavItem>
              </MDBNavbarNav>
            </MDBCollapse>
        </MDBNavbar>
      </Router>
    );
  }
}

export default Mobile_menu;